
import { ActivatedRoute } from '@angular/router';
import { GroupingsService } from './../../../_services/groupings.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subscription-grouping-quiz-show',
  templateUrl: './subscription-grouping-quiz-show.component.html',
  styleUrls: ['./subscription-grouping-quiz-show.component.css']
})
export class SubscriptionGroupingQuizShowComponent implements OnInit {
  myQuiz:Object = undefined
  isGrouping=true
  subscriptionGrouping:Object = undefined
  server_subscription_grouping_id:number=undefined
  subscriptionGroup:Object =undefined
  imageSource:any
  downloading=false
  renderCount=0
  questionCount=0
  loading=false
  renderMathNow=false
  server_quiz_envelop_id:number=undefined
  imageQuestionListCount =[]
  //imageFoundCount=0
  //imageQuestionsCount =0
  lastQuestionRendered=false

  dtOptions: DataTables.Settings = {}
  constructor(private groupingService:GroupingsService,private activatedRoute:ActivatedRoute) { }

  ngOnInit(): void {
    this.loading=true
    this.subscriptionGrouping= this.groupingService.subscriptionGrouping
    this.subscriptionGroup = this.subscriptionGrouping['subscriptionGroup']
    this.server_subscription_grouping_id=this.subscriptionGrouping['server_subscription_grouping_id']
    this.loadQuiz()

  }



  loadQuiz(){
    this.activatedRoute.params.subscribe(
      params=>{
        let server_quiz_id=+params['server_quiz_id']
        this.groupingService.getGroupingQuiz(server_quiz_id).subscribe(
          values=>{
               this.myQuiz=values
               this.questionCount=this.myQuiz["questions"].length
               //this.countImages()
               this.loading=false
          })
      }
    )

    }



renderMathPage(value:boolean){
  this.renderCount+=1
  if(this.renderCount==this.questionCount){
    this.renderMathNow=value
  }
  // Promise.resolve(null).then(() => {
  //   this.renderMathNow=value
  // })
}
// imageFoundEvent(n:number){

//     this.imageFoundCount+=n
//     if((this.imageFoundCount==this.imageQuestionsCount) && this.lastQuestionRendered){
//       this.renderMathPage(true)
//     }
// }
// renderLastQuestion(value:boolean){
//   this.lastQuestionRendered=value
//   if((this.imageFoundCount==this.imageQuestionsCount) && this.lastQuestionRendered){
//     this.renderMathPage(true)
//   }
// }
downloadPdf(quizEnvelopId:number){
  // this.downloading=true
  // this.studentService.getWorksheet(quizEnvelopId).subscribe(
  //   x=>{
  //     this.imageSource= `data:application/pdf;base64,${x}`;
  //     this.downloadMyPdf()

  //   })

}

downloadMyPdf() {

   const link = document.createElement("a");
   let fileName= this.subscriptionGrouping['name']+"_quiz_"+this.myQuiz['server_quiz_id']+"_"+Date.now()
   link.href = this.imageSource;
   link.download = `${fileName}.pdf`
   this.downloading=false
   link.click();

 }

// countImages(){
//   let questions =this.myQuiz['questions']
//   for(let k = 0; k < questions.length;k++){
//     let question = questions[k]
//     if(question.imageListQuestionBody.length>0){
//       this.imageQuestionsCount+=1
//     }

//   }
// }

}
